export default __webpack_public_path__ + "static/media/ipl_3.fcf14b23.png";